module.exports = __webpack_public_path__ + "img/napa_green_winery-1.6231b24f.jpg";